/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../data/addon_metadata';
import '../data/addon_status_for_seller';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "GetAllAddonsRequest": {
                "fields": {
                  "installedOnly": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeWebAddons": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": ".squareup.addons.external.GetAllAddonsRequest.SortOrder",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "ADDON_NAME_ASC"
                    }
                  }
                },
                "nested": {
                  "SortOrder": {
                    "values": {
                      "UNKNOWN": 0,
                      "ADDON_NAME_ASC": 1,
                      "ADDON_NAME_DESC": 2
                    }
                  }
                }
              },
              "GetAllAddonsResponse": {
                "fields": {
                  "addon": {
                    "type": ".squareup.addons.external.GetAllAddonsResponse.Addon",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Addon": {
                    "fields": {
                      "addonId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "metadata": {
                        "type": ".squareup.addons.data.AddonMetadata",
                        "id": 2,
                        "rule": "optional"
                      },
                      "statusForSeller": {
                        "type": ".squareup.addons.data.AddonStatusForSeller",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonsRequest && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonsRequest?.nested?.SortOrder && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonsResponse && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.GetAllAddonsResponse?.nested?.Addon) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetAllAddonsRequest @ squareup/addons/external/get_all_addons.proto at 12:1
 */
export const GetAllAddonsRequest = $root.lookupType('squareup.addons.external.GetAllAddonsRequest');
fixType(GetAllAddonsRequest);
Builder.createAndAttachToType(GetAllAddonsRequest);
/**
 * SOURCE SortOrder @ squareup/addons/external/get_all_addons.proto at 22:3
 */
GetAllAddonsRequest.SortOrder = $root.lookupEnum('squareup.addons.external.GetAllAddonsRequest.SortOrder').values;
/**
 * SOURCE GetAllAddonsResponse @ squareup/addons/external/get_all_addons.proto at 32:1
 */
export const GetAllAddonsResponse = $root.lookupType('squareup.addons.external.GetAllAddonsResponse');
fixType(GetAllAddonsResponse);
Builder.createAndAttachToType(GetAllAddonsResponse);
/**
 * SOURCE Addon @ squareup/addons/external/get_all_addons.proto at 36:3
 */
GetAllAddonsResponse.Addon = $root.lookupType('squareup.addons.external.GetAllAddonsResponse.Addon');
fixType(GetAllAddonsResponse.Addon, {
  addonId: {
    notEmpty: true
  },
  metadata: {
    required: true
  },
  statusForSeller: {
    required: true
  }
});
Builder.createAndAttachToType(GetAllAddonsResponse.Addon);